import { MimeType } from "@rwai/pii-scanner"
import { AcceptFileType } from "../projects/components/CreateProjectForm/FileField"

export function formatTime(seconds: number) {
    if (seconds === 0) {
        return ""
    }

    const roundSeconds = Math.round(seconds)

    const minutes = Math.floor(roundSeconds / 60)
    const remainingSeconds = Math.round(roundSeconds % 60)
    if (minutes === 0) {
        return `${remainingSeconds.toString()}s`
    } else {
        return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`
    }
}

export function convertAcceptFileTypeToMimeType(type: AcceptFileType) {
    switch (type) {
        case AcceptFileType.CSV:
            return MimeType.Csv
        case AcceptFileType.TSV:
            return MimeType.Tsv
        case AcceptFileType.TXT:
            return MimeType.Txt
        case AcceptFileType.XLS:
            return MimeType.Xls
        case AcceptFileType.XLSX:
            return MimeType.Xlsx
    }
}
